var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item flexion"},[_c('input',_vm._b({staticClass:"item large",attrs:{"type":"text","name":_vm.fieldData.fieldName,"placeholder":_vm.$t(`${_vm.fieldData.fieldAttrs.placeholder}`)},domProps:{"value":_vm.fieldData.value},on:{"input":function($event){return _vm.handlerChange($event)}}},'input',_vm.fieldData.fieldAttrs,false))])
}
var staticRenderFns = []

export { render, staticRenderFns }